import React from 'react';
import './USContactInfo.css';

const tAndCUrl = 'https://www.simplybusiness.com/terms-conditions/';
const privacyPolicyUrl = 'https://www.simplybusiness.com/privacy-policy/';
const privacyNoticeCaUrl = 'https://www.simplybusiness.com/privacy-policy/#special-notice-california-residents';
const responsibleDisclosureUrl = 'https://www.simplybusiness.com/responsible-disclosure/';
const doNotSellShareUrl = 'https://www.simplybusiness.com/personal-information/';

const USContactInfo = (): React.JSX.Element => (
  <div className="us-contact-info" data-testid="us-contact-info">
    <div className="us-contact-info__address">
      <h2 className="us-contact-info__heading">Address</h2>
      <p className="us-contact-info__text">Simply Business</p>
      <p className="us-contact-info__text">53 State Street, 19th Floor</p>
      <p className="us-contact-info__text">Boston, MA</p>
      <p className="us-contact-info__text">02109</p>
    </div>
    <div className="us-contact-info__links">
      <h2 className="us-contact-info__heading">Legal</h2>
      {/* list-style: none strips the list semantics in Safari; the role puts them back. */}
      <ul className="us-contact-info__legal-list" role="list">
        <li className="us-contact-info__legal-item">
          <a className="us-contact-info__link" href={tAndCUrl} target="_blank" rel="noopener">Terms of Service</a>
        </li>
        <li className="us-contact-info__legal-item">
          <a className="us-contact-info__link" href={privacyPolicyUrl} target="_blank" rel="noopener">Privacy Policy</a>
        </li>
        <li className="us-contact-info__legal-item">
          <a className="us-contact-info__link" href={privacyNoticeCaUrl} target="_blank" rel="noopener">
            Privacy Notice for CA Residents
          </a>
        </li>
        <li className="us-contact-info__legal-item">
          <a className="us-contact-info__link" href={responsibleDisclosureUrl} target="_blank" rel="noopener">
            Responsible Disclosure Policy
          </a>
        </li>
        <li className="us-contact-info__legal-item">
          <a className="us-contact-info__link" href={doNotSellShareUrl} target="_blank" rel="noopener">
            Do Not Sell or Share my Personal Information (CA Residents)
          </a>
        </li>
      </ul>
    </div>
  </div>
);

export default USContactInfo;
